










import Vue from "vue";

export default class Footer extends Vue {
  get thisYear() : number {
    return new Date().getFullYear();
  }
}
